import { useTheme } from "@/hooks/useTheme";

export const BrandImg = ({ kind = "rhett", ...props }) => {
  const theme = useTheme();
  return <img src={`/brand/${kind}-${theme === "light" ? "black" : "white"}.webp`} {...props} />;
};
